import React from 'react';
import {connect} from "react-redux";
import Comment from './../comment/comment';
import {TertiaryLink} from "@sfly/uig-button";

const Confirmation = props => {
    return (
        <div className="delete-icon">
            <p>
                {props.message}
            </p>
        </div>
    )
}

class Comments extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            moreOptionComment: {}
        }
    }

    componentWillReceiveProps(nextProps) {
        this.props = nextProps;
    }

    onClickMore = (comment) => {
        // console.log('onClickMore', comment);
        this.setState({
            moreOptionComment: comment
        });
    }
    // function isMobile() {
    //     return window.innerWidth <= 840 || window.innerHeight <= 600;
    // }

    getExtraStyles = (comment) => {
        let firstRecent = false;
        for (let i = 0; i < this.props.comments.comments.length; i++) {
            if (this.props.comments.comments[i].id === comment.id && !firstRecent) {
                return {
                    marginTop: "15px"
                }
            }

            if (this.props.comments.comments[i].recent) {
                firstRecent = true;
            }
        }
        return {};
    }


    render() {
        const {comments, latestComments, totalComments} = this.props.comments;

        return (<div className="comments-section">
            {
                this.props.comments.notification.show &&
                <Confirmation message={this.props.comments.notification.message}/>
            }

            {

                comments.map((_comment, index) => {
                    if (_comment.recent) {
                        return null;
                    }
                    return (<Comment
                        originalSharedProjectGuid={this.props.originalSharedProjectGuid}
                        onEdit={this.props.onEdit}
                        comment={_comment}
                        key={_comment.id}
                        userId={this.props.userId}
                        onClickMore={this.onClickMore}
                        moreOptionComment={this.state.moreOptionComment}/>)
                })
            }
            {
                (!this.props.comments.allCommentsLoaded && totalComments > comments.length) &&
                <TertiaryLink onClick={this.props.loadMore}>View more comments</TertiaryLink>

            }

            {
                comments.map((_comment, index) => {
                    if (_comment.recent) {
                        return (<Comment
                            originalSharedProjectGuid={this.props.originalSharedProjectGuid}
                            onEdit={this.props.onEdit}
                            comment={_comment}
                            key={"comments" + index}
                            userId={this.props.userId}
                            onClickMore={this.onClickMore}
                            moreOptionComment={this.state.moreOptionComment}
                            style={this.getExtraStyles(_comment)}
                        />)
                    }
                    return null;
                })
            }
        </div>)
    }
}

const mapStateToProps = state => {
    return {
        comments: state.comments,
        user: state.user
    }
}

const dispatchPropsToState = {}

export default connect(mapStateToProps, dispatchPropsToState)(Comments);